import React, { useState } from 'react';
import PasswordInput from '../components/PasswordInput';

export default function AdminCustomerPasswordReset({ customer, resetCustomerPassword }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Password and confirmation do not match.');
      return;
    }
    setBusy(true);
    try {
      const res = await resetCustomerPassword(customer.id, password, confirm);
      if (!res.ok) {
        setError(res.error || 'Could not reset password.');
        return;
      }
      setPassword('');
      setConfirm('');
      setSuccess(
        res.message ||
          `Password updated for @${res.username || customer.username}. Tell them by phone or WhatsApp — they can also sign in with checkout email after you set this password.`
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="account-customer-password-reset">
      <h4 className="account-customer-card__detail-title">Reset password</h4>
      <p className="small text-muted mb-2">
        Use when <strong>Forgot password</strong> email is not working. Choose a temporary password and share it
        with the customer securely (call or WhatsApp). They sign in with their <strong>checkout email</strong> or
        username <code className="small">@{customer.username}</code>.
      </p>
      {success ? (
        <div className="alert alert-success py-2 small mb-2" role="status">
          {success}
        </div>
      ) : null}
      {error ? (
        <div className="alert alert-danger py-2 small mb-2" role="alert">
          {error}
        </div>
      ) : null}
      <form onSubmit={onSubmit} className="account-customer-password-reset__form" noValidate>
        <div className="row g-2">
          <div className="col-sm-6">
            <label className="form-label small mb-1" htmlFor={`cust-pw-${customer.id}`}>
              New password
            </label>
            <PasswordInput
              id={`cust-pw-${customer.id}`}
              className="form-control form-control-sm checkout-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              disabled={busy}
              required
            />
          </div>
          <div className="col-sm-6">
            <label className="form-label small mb-1" htmlFor={`cust-pw2-${customer.id}`}>
              Confirm
            </label>
            <PasswordInput
              id={`cust-pw2-${customer.id}`}
              className="form-control form-control-sm checkout-input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              disabled={busy}
              required
            />
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-outline-primary btn-sm rounded-pill mt-2"
          disabled={busy}
        >
          {busy ? 'Saving…' : 'Set new password'}
        </button>
      </form>
    </div>
  );
}
